import { useCallback } from 'react';
import { Region } from '@jucy-ui/common';
import { useSearchFormStore } from './useSearchFormStore';

export const useSortRegions = () => {
    const store = useSearchFormStore();
    const region = store.sortRegion;
    return useCallback((regions: Region[]) => regions.slice().sort((a) => (a.countryCode === region ? -1 : 1)), [region]);
};
